import React from 'react';
import styles from './index.module.scss';
import { colorizeMahatriaInfinitheism } from '../ColorizeMahatriaInfinitheism';

interface PreferenceChipProps {
  name: string;
  id?: string | number;
  isAllocated: boolean;
  allocatedProgramId?: string | number;
  onPrefClick: (pref: any) => void;
  isSeekerOverlay?: boolean; 
}

export const PreferenceChip: React.FC<PreferenceChipProps> = ({
  name,
  id,
  isAllocated,
  allocatedProgramId,
  onPrefClick,
  isSeekerOverlay = false, 
}) => {
  return (
    <span
      className={`
        ${styles.preferenceChip}
        ${isAllocated && allocatedProgramId === id ? styles.allocatedChip : ''}
      `}
      onClick={(e) => {
        e.stopPropagation();
        onPrefClick({ name, id });
      }}
     style={!isSeekerOverlay ? { cursor: 'pointer' } : undefined} 
    >
      {colorizeMahatriaInfinitheism(name)}
    </span>
  );
};